import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

export function useOnClick(props) {
  let [, notify] = useNotifications()

  return async function onClick() {
    try {
      // eslint-disable-next-line compat/compat
      await navigator.clipboard.writeText(props.value)
      notify(notifySuccess('Copied to clipboard'))
    } catch (error) {
      notify(notifyError('Failed to copy to clipboard'))
    }
  }
}
